import React, { useState, useRef, useEffect } from 'react'; // Adicionado useEffect
import apiClient from '../../api';
import { Link, useNavigate } from 'react-router-dom'; // Adicionado useNavigate
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';

// Componentes reutilizáveis
import Header from '../../components/layout/Header';
import { Button } from '../../components/common/Button';
import { FormGroup, Label, Input, Message } from '../../components/common/Forms';

import { AuthPageContainer, AuthFormCard, Title } from '../../components/common/AuthLayout';

// --- Styled Components (Mantidos iguais) ---
const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  
  label {
    margin-bottom: 0;
    font-weight: normal;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const LinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  font-size: 0.9rem;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

// Componente principal
function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mensagem, setMensagem] = useState({ text: '', type: '' });
  const [lembrar, setLembrar] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser && parsedUser.cliente_id) {
            navigate('/home');
        }
      } catch (error) {
        console.error("Erro ao ler usuário do cache local", error);
      }
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!recaptchaToken) {
      setMensagem({ text: 'Por favor, confirme que você não é um robô.', type: 'error' });
      return;
    }
    setIsLoading(true);
    setMensagem({ text: '', type: '' });
    try {
      const resposta = await apiClient.post(`/api/login`, { 
        email, 
        senha, 
        lembrar, 
        recaptcha_token: recaptchaToken 
      });
      setMensagem({ text: 'Login realizado com sucesso!', type: 'success' });
      
      onLogin?.({
        nome: resposta.data.nome,
        cliente_id: resposta.data.cliente_id,
        email: resposta.data.email,
        role: resposta.data.role
      });
      
      navigate('/home');

    } catch (error) {
      setSenha('');
      setMensagem({
        text: error.response?.data?.error || 'Erro ao realizar login.',
        type: 'error'
      });
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setRecaptchaToken(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />
      <AuthPageContainer>
        <AuthFormCard>
          <Title>Acessar Plataforma</Title>
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="email">Email:</Label>
              <Input 
                id="email"
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                type="email" 
                required 
                placeholder="seu@email.com"
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="senha">Senha:</Label>
              <Input 
                id="senha"
                value={senha} 
                onChange={e => setSenha(e.target.value)} 
                type="password" 
                required 
                placeholder="Sua senha"
              />
            </FormGroup>

            <FormGroup style={{ display: 'flex', justifyContent: 'center' }}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setRecaptchaToken(token)}
                onExpired={() => setRecaptchaToken(null)}
              />
            </FormGroup>

            <CheckboxWrapper>
              <input
                type="checkbox"
                checked={lembrar}
                onChange={e => setLembrar(e.target.checked)}
                id="lembrar"
                style={{ width: 'auto' }}
              />
              <label htmlFor="lembrar">Lembrar de mim</label>
            </CheckboxWrapper>

            <ButtonContainer>
              <Button 
                type="submit" 
                style={{ width: '100%' }} 
                disabled={isLoading}
              >
                {isLoading ? 'Entrando...' : 'Entrar'}
              </Button>
              <LinksContainer>
                <StyledLink to="/recuperar-senha">Esqueceu sua senha?</StyledLink>
                <StyledLink to="/">Voltar para o Início</StyledLink>
              </LinksContainer>
            </ButtonContainer>
          </form>

          {mensagem.text && <Message type={mensagem.type}>{mensagem.text}</Message>}
        </AuthFormCard>
      </AuthPageContainer>
    </>
  );
}

export default LoginPage;